(function () {
  if (!window.customElements || customElements.get('search-overlay')) return;

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  class SearchOverlay extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('[data-section-id]');
      this.panel = this.querySelector('[data-search-panel]');
      this.input = this.querySelector('[data-search-input]');
      this.closeButton = this.querySelector('[data-search-close]');
      this.opener = null;

      this.onOpenerClick = this.onOpenerClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      document.addEventListener('click', this.onOpenerClick);
      document.addEventListener('keydown', this.onKeydown);
      if (this.closeButton) this.closeButton.addEventListener('click', this.onCloseClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOpenerClick);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.onCloseClick);
      if (this.host) this.host.classList.remove('is-search-open');
      this.unlockScroll();
    }

    get isOpen() {
      return !this.hidden;
    }

    onOpenerClick(event) {
      const opener = event.target.closest ? event.target.closest('[data-search-open]') : null;
      if (!opener) return;

      event.preventDefault();
      this.opener = opener;
      this.open();
    }

    onCloseClick(event) {
      event.preventDefault();
      this.close();
    }

    onKeydown(event) {
      if (!this.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      const items = Array.prototype.slice.call(this.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
      if (items.length === 0) return;

      const first = items[0];
      const last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open() {
      if (this.isOpen) return;

      this.hidden = false;
      if (this.host) this.host.classList.add('is-search-open');
      this.lockScroll();

      requestAnimationFrame(() => {
        this.classList.add('is-open');
        if (this.input) this.input.focus();
      });
    }

    close() {
      if (!this.isOpen) return;

      this.classList.remove('is-open');
      this.hidden = true;
      if (this.host) this.host.classList.remove('is-search-open');
      this.unlockScroll();

      if (this.opener && document.contains(this.opener)) {
        this.opener.focus();
        this.opener = null;
      }
    }

    lockScroll() {
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    unlockScroll() {
      if (this.previousOverflow === undefined) return;
      document.body.style.overflow = this.previousOverflow;
      this.previousOverflow = undefined;
    }
  }

  customElements.define('search-overlay', SearchOverlay);
})();
